import { reviews } from '@/mocks/reviews';

export default function ReviewsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-12">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-foreground-500 tracking-wider uppercase">Reviews</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950">
            读者口碑
            <br />
            听听他们怎么说
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md">
            数百万读者的真实评价，他们在这里找到了心仪的韩漫
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <article
              key={review.id}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              {/* Title */}
              <h4 className="font-heading text-sm font-bold text-foreground-900 mb-2">
                太棒了！
              </h4>
              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                {review.content}
              </p>
              {/* Author */}
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">{review.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}